module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_6005.7b67ba9e.png";